export default [
	{
		path: '/admin/repair-product-profiles',
		name: 'repair-product-profile',
		meta: { requiresAuth: true },
		component: () => import('@/pages/customer-service/repair-product-profile')
	}
]